export default {
  product: {
    title: '產品',
    selfCustodyWallet: '手機錢包',
    selfCustodyWalletDesc: '區塊鏈入口，手機上的多鏈錢包',
    hardwareWallet: '硬體錢包',
    hardwareWalletDesc: '用keypal守護您的資產，安全、放心',
    extensionWallet: '挿件錢包',
    extensionWalletDesc: '讓您更友好的體驗電腦端錢包',
    transit: 'Transit',
    transitDesc: '多鏈DEX聚合閃兌與NFT市場平臺',
    fiveDegrees: '5Degrees',
    fiveDegreesDesc: 'Web3.0社交協定',
    stakeVault: '質押寶',
    stakeVaultDesc: '支持自託管質押節點和小額靈活質押節點',
  },
  project: {
    subToken: '提交代幣',
    subDApp: '提交DApp',
    subNFT: '提交NFT',
    subChain: '提交公鏈',
  },
  assets: {
    title: '資產',
  },
  collaborations: {
    title: '项目合作',
  },
  community: {
    title: '社區',
    developers: '開發者',
    recruiting: 'TP俠',
  },
  helpCenter: {
    title: '幫助中心',
  },
  features: {
    title: '功能',
    buyCrypto: '購買加密資產',
    mobileWallet: '手機錢包',
    hardwareWallet: '硬體錢包',
    extensionWallet: '挿件錢包',
    desktop: '桌面端錢包',
    fiveDegrees: '5Degrees',
    versionVerification: '版本校验',
    approvalDetector: '授權檢測',
    tokenSecurity: '代幣安全',
    keyGenerator: '私鑰生成器',
    BATCH_SENDER: '批量轉賬',
  },
  information: {
    title: '信息',
    blockchainGuide: '區塊鏈小白書',
    tronWallet: '波場小白書',
    iostWallet: 'IOST小白書',
    tpMan: 'TP俠',
  },
  developers: {
    title: '開發者',
    github: 'Github (TP-Lab)',
    devCenter: '開發者中心',
    subToken: '提交代幣',
    subDApp: '提交DApp',
    subNFT: '提交NFT',
  },
  company: {
    title: '公司',
    about: '關於',
    careers: '招聘',
    pressKit: '品牌素材',
    swagShop: '周邊商店',
  },
  support: {
    title: '支持',
    helpCenter: '幫助中心',
    contactUs: '聯繫我們',
  },
  legal: {
    title: '法律',
    privacyPolicy: '隱私策略',
    terms: '服務協議',
  },
  main: {
    title: '版本驗證',
    language: '繁體中文',
    intro:
      '版本驗證通過比對不同版本之間的MD5或SHA256雜湊值來進行。請確保透過官方渠道下載TokenPocket錢包，以避免被欺騙。關於如何獲取某個版本的MD5或SHA256雜湊值的說明，請參考',
    tutorial: '教程 >',
    system: '操作系統',
    android: 'Android',
    ios: 'iOS',
    version: '版本',
    allVersion: '全部',
    appChannel: '應用渠道',
    developer: '開發者',
    allChannel: '全部',
    md5: 'MD5',
    sha256: 'SHA256',
    log: '版本日誌',
    check: '詳情',
    versionLog: '版本日誌',
    confirm: '確認',
    aboutIOS: '關於iOS版本',
    IOSDesc:
      '對於iOS版本，我們僅在App Store上提供我們的應用。只有透過App Store下載的應用程序才能正確安裝。因此，在使用蘋果設備時，請確保將App Store驗證為唯一的下載渠道。',
    IOSDesc_2:
      '在2022年10月8日之前從App Store下載的版本的開發者是TOKENPOCKET FOUNDATION LTD，這是TokenPocket開發的早期版本。這是一個合法的錢包，可以正常使用，但更新服務將暫時停止。',
    aboutAndroid: '關於安卓版本',
    androidDesc: '當前TokenPocket提供安卓下載的渠道包括：官網、谷歌商店、三星應用商店、華為應用商店、OPPO應用商店、Vivo應用商店。由於個別應用商店在下載過程中無法獲取到apk安裝包，因此無法進行MD5或SHA256計算校驗！所以，請您在下載的時候，務必核對清楚開發商信息，參照下方',
    IOSAppName: '應用名稱：',
    TPWallet: 'TP錢包',
    AppIcon: '應用圖示：',
    AppDeveloper: '開發者：',
    downloadLink: '下載連結：',
    copied: '已複製！',
    versionVerification: '版本校验',
  },
  follow: {
    title: '關注我們',
    desc1: 'TokenPocket 客服不會私聊您！',
    desc2:
      '請注意，您即將進入TokenPocket社區，您進入社區可能會有人假冒TokenPocket的工作人員私聊您，請您務必警惕，所有私聊您的都可能是騙子！ TokenPocket工作人員不會主動跟您私信！',
    desc3: '知道了，繼續前往',
  },
};
